import HtmlView from "@/components/views/HtmlView";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { ClientsListView } from "../../../../../../client/components/ClientsListView";
import { ClientFormType } from "../../../../../../client/enums";
import { Client } from "../../../../../../client/types";
import { GenericInsurance } from "../../../../../types";

interface Props {
  insurance: GenericInsurance;
  insuredClient?: Client;
}

const GenericInsuranceView = ({ insurance, insuredClient }: Props) => {
  const { t } = useTranslation();

  const { insuranceData } = insurance;

  return (
    <>
      <Descriptions
        size="small"
        bordered
        styles={{ label: { width: 200 } }}
        items={[
          {
            label: t("contract.attrs.insurances.insuranceData.description"),
            children: <HtmlView value={insuranceData.description} />,
          },
        ]}
      />

      {insuredClient && (
        <ClientsListView
          className="margin-top-medium"
          clientsData={[
            {
              client: insuredClient,
              clientFormTypes: [ClientFormType.INSURED],
            },
          ]}
        />
      )}
    </>
  );
};

export default GenericInsuranceView;
